import {
  ACTION_ADD_ALL_PROMOTED_SITE_TO_WL_TEMPLATE_TO_LANGS,
} from '../actionTypes';


export const actionAddAllPromotedSiteToWlTemplateToLangs = promotedSiteToWlTemplateToLangs => ({
  type: ACTION_ADD_ALL_PROMOTED_SITE_TO_WL_TEMPLATE_TO_LANGS,
  payload: { promotedSiteToWlTemplateToLangs },
});
